import { Instagram } from "lucide-react";
import { INSTAGRAM_HANDLE, INSTAGRAM_URL } from "../../data/content";
import { scrollToSection } from "../../lib/scroll";
import NewsletterSignup from "./NewsletterSignup";

const Footer = () => (
    <footer data-testid="footer" className="border-t border-line bg-cream">
        <NewsletterSignup />
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 grid grid-cols-1 md:grid-cols-12 gap-10 items-start">
            <div className="md:col-span-5">
                <p className="font-display text-3xl text-ink">
                    José Luis <span className="italic text-crimson">Garcés Maldonado</span>
                </p>
                <p className="mt-3 font-display italic text-lg text-ink/70 max-w-xs leading-snug">
                    Aún hay fotografías que se hacen con palabras.
                </p>
            </div>
            <div className="md:col-span-4 flex flex-col gap-3 font-mono text-[11px] uppercase tracking-[0.22em] text-subtle">
                <a
                    data-testid="footer-link-merch"
                    href="/versos-para-llevar"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="self-start link-underline text-crimson hover:text-ink transition-colors"
                >
                    Versos para llevar ↗
                </a>
                {[
                    ["#historia", "Historia"],
                    ["#libros", "Libros"],
                    ["#poemas", "Poemas"],
                    ["#video-poesia", "Vídeo poesía"],
                    ["#canciones", "Canciones"],
                    ["#contacto", "Contacto"],
                ].map(([hash, label]) => (
                    <button
                        key={hash}
                        data-testid={`footer-link-${label.toLowerCase().replace(" ", "-")}`}
                        onClick={() => scrollToSection(hash)}
                        className="self-start link-underline hover:text-ink transition-colors"
                    >
                        {label}
                    </button>
                ))}
            </div>
            <div className="md:col-span-3 flex flex-col gap-4 md:items-end">
                <a
                    data-testid="footer-instagram-link"
                    href={INSTAGRAM_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.22em] text-ink hover:text-crimson transition-colors"
                >
                    <Instagram size={15} />
                    {INSTAGRAM_HANDLE}
                </a>
                <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-subtle">
                    Quito, Ecuador
                </p>
            </div>
        </div>
        <div className="border-t border-line">
            <p className="max-w-7xl mx-auto px-5 sm:px-8 py-5 font-mono text-[10px] uppercase tracking-[0.2em] text-subtle">
                © {new Date().getFullYear()} José Luis Garcés Maldonado — Todos los poemas son propiedad de su autor
            </p>
        </div>
    </footer>
);

export default Footer;
